// store/thunks/auth/sendPhoneCodeThunk.ts

import { createAdminAsyncThunk } from "@/store/thunks/createAdminAsyncThunk";
import { VerificationDTO } from "@/types/dtos.types";

export const sendPhoneCodeThunk = createAdminAsyncThunk<
  VerificationDTO,
  undefined,
  { rejectValue: { message: string } }
>(
  'auth/sendPhoneCode',
  async(_, { extra: { authService }, rejectWithValue }) => {
    try {
      return await authService.sendPhoneCode();
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to send email code';
      return rejectWithValue({ message });
    }
  }
);
